import * as React from 'react'
import _ from 'lodash'
import type { CommonDeps } from '../base/CommonDeps'
import { renderCatch } from '../error/renderCatch'
import { SearchableDropdown } from '../ui/SearchableDropdown'
import { type KnownUnit, type Unit, unitName } from './unit'
import { getSearchTree } from './helpers'
import { UnitImage } from './UnitImage'
import type { RenderCachedImage } from '../image/WithCachedImage'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'

interface Props {
    deps: CommonDeps
    onSelect: (unitId: Nullable<number>) => void
    renderCachedImage: RenderCachedImage
    selectedUnitId: number
    units: Unit[]
    // ancestors cannot be selected directly, they are just there to group the
    // units passed in `units`
    ancestors?: KnownUnit[]
    placeholder?: string
    disabled?: boolean
    overlay?: boolean
}

export class UnitSelect extends React.Component<Props, {}> {
    public render = () => renderCatch(this.props.deps, this.tryRender)

    private getDropdownOptions() {
        // Sort options alphabetically by label
        return _.sortBy(
            this.props.units.map((unit) => ({
                id: unit.id,
                label: unitName(unit),
                leftNode: (
                    <UnitImage deps={this.props.deps} renderCachedImage={this.props.renderCachedImage} unit={unit} />
                ),
            })),
            'label'
        )
    }

    private tryRender = () => {
        const { deps, renderCachedImage, units, ancestors, disabled, overlay } = this.props
        return (
            <SearchableDropdown<number>
                language={this.props.deps.language}
                selectedValue={this.props.selectedUnitId}
                onChange={this.props.onSelect}
                options={this.getDropdownOptions()}
                placeholder={this.props.placeholder}
                searchTree={ancestors && getSearchTree(deps, renderCachedImage, units, ancestors)}
                disabled={disabled}
                overlay={overlay}
            />
        )
    }
}
